import type { KPIListItem } from "../../domain/types";

export type KpiLevel = KPIListItem["level"];

export const KPI_LEVEL_LABELS: Record<KpiLevel, string> = {
  employee: "ພະນັກງານ",
  position: "ຕຳແໜ່ງ",
  department: "ພະແນກ",
  organization: "ອົງກອນ",
};

export function getKpiLevelLabel(
  level: string | null | undefined,
): string {
  if (!level) return KPI_LEVEL_LABELS.employee;
  return KPI_LEVEL_LABELS[level as KpiLevel] ?? level;
}

/** KPI level → assignment type (organization ใช้ department assignment) */
export function mapKpiLevelToAssignmentType(
  level: KpiLevel,
): "employee" | "position" | "department" {
  if (level === "employee") return "employee";
  if (level === "position") return "position";
  return "department";
}

export const KPI_LEVEL_FILTER_OPTIONS = [
  { value: "all", label: "ທັງໝົດ" },
  ...(
    Object.entries(KPI_LEVEL_LABELS) as Array<[KpiLevel, string]>
  ).map(([value, label]) => ({ value, label })),
];

export const KPI_LEVEL_BADGE_VARIANT: Record<
  KpiLevel,
  "default" | "secondary" | "outline"
> = {
  employee: "default",
  position: "secondary",
  department: "secondary",
  organization: "outline",
};
